module.exports = __webpack_public_path__ + "static/media/mool-yueguang.cbeaf059.png";